export default function Header({ project, children: actions }) {
  return (
    <div className="relative flex w-full">
      <h1 className="mb-4 w-full border-b pb-4 text-4xl font-bold">
        {project.name}
      </h1>
      {actions && (
        <div className="absolute right-0 space-x-3 sm:top-2">{actions}</div>
      )}
    </div>
  );
}
